import { Component } from '@angular/core';
import { ActionButton } from '@wdx/shared/utils';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { MoleculeActionButtonModule } from '../../../../../components/molecules/molecule-action-button/molecule-action-button.module';

@Component({
    selector: 'clmi-action-button-cell-renderer',

    imports: [MoleculeActionButtonModule],
    templateUrl: './action-button-cell-renderer.component.html',
    styleUrls: ['./action-button-cell-renderer.component.scss'],
    host: { class: 'd-flex h-100 align-items-center' },
})
export class ActionButtonCellRendererComponent implements ICellRendererAngularComp {
    public actionButton: ActionButton;

    agInit(params: ICellRendererParams<any, ActionButton>): void {
        this.actionButton = params.value;
    }

    refresh(params: ICellRendererParams): boolean {
        this.actionButton = params.value;
        return false;
    }
}
